import axios from './AxiosHost';
import axiosUpload from './AxiosUpload';
import uploadErrorMessages from './UploadErrorMessages.js'

export default class ModUpload{
    
    constructor(data, authKey){
        this.uploadData = data;
        this.authKey = authKey;
        this.uploadFileService = this.uploadFileService.bind(this);
        this.createFile = this.createFile.bind(this);
        this.validateFile = this.validateFile.bind(this);
        this.uploadErrorMessages = uploadErrorMessages;
    }

    async getAttachmentsData(authKey, callback){
        var res = await axios.get('Attachment/GetModel/' + authKey);
        callback(res.data);
    }

    async uploadFileService(filesData, callback){
        let files = filesData.files

        let validationErrors = [];
        for(let i= 0; i < files.length; i++){
            let res = this.validateFile(files[i]);
            if(res.status != "success"){
                validationErrors.push({
                    message: res.message
                });
            }
        }

        if(validationErrors.length > 0){
            let errors = "";
            for(let f = 0; f < validationErrors.length; f++){
                errors += validationErrors[f].message + "\n";
            }
            callback({ status: "error", message: errors});
        }
        else{
            let url = this.uploadData.UploadUrl;
            
            const formData = new FormData();
            for(let i= 0; i < files.length; i++){
                formData.append('file', files[i]);
            }
            const config = {
                headers: {
                    'token' : this.uploadData.Sts
                }
            }
            console.log(config);
            
            debugger;
            console.log(axiosUpload);
            
            axiosUpload.post(url, formData, config).then(res => {
                if(res.status == 200 && res.data.files){
                    if(res.data.status.type == "success" && res.data.files.length > 0){
                        for(let j = 0; j < res.data.files.length; j++){
                            this.createFile(res.data.files[j], filesData.fileType, (res) => {
                                callback(res);
                            });
                        }
                    }
                    else{
                        callback({ status: "error", message: this.uploadErrorMessages[res.data.status.code] });
                    }
                }
                else{
                    callback({ status: "error", message: res.statusText});
                }
            });
        }
    }

    async deleteFileService(id, callback){
        let fileData = {
            Id: id,
            Action: "DELETE"
        }
        await axios.post('Attachment/Post/' + this.authKey, fileData).then(res => {
            let toRet = ""
            if(res.status == "200"){
               toRet = { status: "success" };
            }
            else{
                toRet = { status: "error", message: res.message }
            }
            callback(toRet);
        });
    }

    async createFile(file, fileType, callback){
        if(file.status.type == "success"){
            debugger;
            let fileData = {
                FileName: file.sourceFileName,
                ServerFileName: file.destinationFileName,
                Extension: file.extension,
                Size: file.size,
                Type: fileType,
                Action: "ADD"
            }
            await axios.post('Attachment/Post/' + this.authKey, fileData).then(res => {
                if(res.status == "201"){
                    callback({ status: "success" });
                }
                else{
                    callback({ status: "error", message: res.message });
                }
            });
        }
        else{
            callback({ status: "error", message: this.uploadErrorMessages[file.status.code] });
        }
    }

    validateFile(file)
    {
        let temp = file.name.split(".");
        let extension = "." + temp[temp.length - 1];

        let mimeTypeArr = this.uploadData.MimeTypes.filter(function(element){ return element == extension });
        if (mimeTypeArr.length == 0) {
            console.log(["Mimetype not allowed"]);
            return { status: "error", message: this.uploadErrorMessages["1006"] }
        }

        if(this.uploadData.TotalSize - file.size/1024 < 0){
            console.log(["File size is bigger then size left to upload"]);
            return { status: "error", message: this.uploadErrorMessages["1002"] }
        }

        if(file.size/1024 > this.uploadData.Size){
            console.log(["File size is bigger then allowed"]);
            return { status: "error", message: this.uploadErrorMessages["1003"] }
        }

        if(file.size == 0){
            console.log(["File is empty"]);
            return { status: "error", message: this.uploadErrorMessages["1008"] }
        }

        return { status: "success" }
    }

    // async uploadFile (init, file, type, callback) { //pass list of files since it can be multiple e.target.files[0]
    //     let token = await axios.get(init.uploadTokenUrl, init.uploadAppId);

    //     const formData = new FormData();
    //     formData.append('type',type);
    //     formData.append('file',file);

    //     const config ={header: {'content-type': 'multipart/form-data'}};
    //     var res = await axios.post(init.uploadFileUrl, file, config);
    //     callback(res);
    //     return res;
    // }

    async downloadFileService(authKey, id, callback){
        debugger;
        let res = await axios.request({url: 'Attachment/Download/?authKey=' + authKey + "&attachmentId=" + id, method: 'get', responseType: 'blob'});
        callback(res)
    }
}